export enum TemplateModalEnum {
    DEFAULT,
    WARNING,
    SUCCESS,
    ERROR
}